function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChristmasIslandFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#5EAA22",
      d: "M0 3h24v18H0V3Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#4141DB",
      d: "m0 3 24 18H0V3Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "m4.5 9.75-.75.549.1-.924L3 9l.85-.375-.1-.924.75.549.75-.549-.1.924L6 9l-.85.375.1.924-.75-.549ZM3 14.25l-.75.549.1-.924-.85-.375.85-.375-.1-.924.75.549.75-.549-.1.924.85.375-.85.375.1.924L3 14.25ZM6 18.75l-.75.549.1-.924L4.5 18l.85-.375-.1-.924.75.549.75-.549-.1.924.85.375-.85.375.1.924L6 18.75ZM6.75 11.625l-.375.274.05-.461L6 11.25l.425-.188-.05-.461.375.274.375-.274-.05.461.425.188-.425.188.05.461-.375-.274Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FECA00",
      d: "M16.17 12.168c-.28-.292 2.243-.98 2.505-1.866.347-.771.115-1.397-1.195-1.946-1.31-.549-2.633-1.61-1.11-1.61 1.521 0 1.521.217 1.93.857.409.64 1.293.777 1.311 0 0-1.325.125-1.503-.944-2.654s2.681.473 2.371 2.447c-.31 1.974-.683 1.337-.446 1.668.237.331 1.662-.697 1.484.673-.498.788-1.487 1.96-5.905 2.43Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FECA00",
      d: "M12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#548650",
      d: "M9.715 10.621c.425-.094 1.007 1.045 2.056.617 1.05-.427 1.27-1.242 1.768-.944.5.299.565 1.017.232 1.379-.332.36-.896.446-.896.903s-.11 2.085-.326 1.613c-.646-.524-.252-1.36-1.048-1.613-.796-.254-1.28-.245-1.866-.138-.587.107.394-.294.602-.675.424-.407-.717-1.006-.522-1.142Z"
    })]
  })]
}));
//# sourceMappingURL=ChristmasIsland.js.map